import { useState, useEffect } from "react";
import styles from "./Notifications.module.scss";
import { FaTimes } from "react-icons/fa";
import IconButton from "@mui/material/IconButton";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import ListNotifications from "./ListNotifications/ListNotifications";
// import { UpdateSession } from "../../utils/session";
import ClickAwayListener from "@mui/base/ClickAwayListener";
import Swal from "sweetalert2";

export default function Notifications({ setNotification, getUnseen }) {
  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }
  const [value, setValue] = useState(0);
  const [notifications, setNotifications] = useState(null);
  const [newNotifications, setNewNotifications] = useState(null);
  const getAllNotifications = async () => {
    await fetch(
      `${process.env.REACT_APP_API_URL}/event/get_user_seen_notifications`,
      {
        method: "POST",
        header: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          jwt: localStorage.getItem("user_token"),
          user_id: localStorage.getItem("user_id"),
        }),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        if (res.status === "success") {
          setNotifications(res.data);
          // UpdateSession(res.jwt);
        } else {
          Swal.fire({
            text: res.message,
            icon: "error",
            confirmButtonColor: "#999",
          });
        }
      });
  };
  const getNewNotifications = async () => {
    await fetch(
      `${process.env.REACT_APP_API_URL}/event/get_user_unseen_notifications`,
      {
        method: "POST",
        header: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          jwt: localStorage.getItem("user_token"),
          user_id: localStorage.getItem("user_id"),
        }),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        if (res.status === "success") {
          setNewNotifications(res.data);
          res.data.length === 0 && setValue(1); // zmiana na wszystkie
          // UpdateSession(res.jwt);
        } else {
          Swal.fire({
            text: res.message,
            icon: "error",
            confirmButtonColor: "#999",
          });
        }
      });
  };
  const action = (type, id) => {
    if (type === "mark") {
      fetch(`${process.env.REACT_APP_API_URL}/event/mark_as_seen`, {
        method: "POST",
        header: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          jwt: localStorage.getItem("user_token"),
          event_notification_id: id,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          if (res.status === "success") {
            getNewNotifications();
            getAllNotifications();
            getUnseen();
            // UpdateSession(res.jwt);
          } else {
            Swal.fire({
              text: res.message,
              icon: "error",
              confirmButtonColor: "#999",
            });
          }
        });
    }
  };
  const markAll = () => {
    fetch(`${process.env.REACT_APP_API_URL}/event/mark_everything_as_seen`, {
      method: "POST",
      header: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        jwt: localStorage.getItem("user_token"),
        user_id: localStorage.getItem("user_id"),
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.status === "success") {
          getNewNotifications();
          getAllNotifications();
          getUnseen();
          // UpdateSession(res.jwt);
        } else {
          Swal.fire({
            text: res.message,
            icon: "error",
            confirmButtonColor: "#999",
          });
        }
      });
  };
  useEffect(() => {
    getAllNotifications();
    getNewNotifications();
    getUnseen();
  }, [value]);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <div className={styles.notificationsWrapper}>
      <ClickAwayListener
        onClickAway={() => {
          setNotification(false);
        }}
      >
        <div>
          <div className={styles.top}>
            <IconButton
              className={styles.closeButton}
              onClick={() => {
                setNotification(false);
              }}
            >
              <FaTimes />
            </IconButton>
            <span className={styles.title}>
              Powiadomienia <span onClick={markAll}>odznacz wszystkie</span>
            </span>
          </div>

          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab
                  label={
                    <span>
                      Nowe{" "}
                      {newNotifications !== null && (
                        <span
                          className={styles.number}
                          style={
                            value === 0 ? { backgroundColor: "#2d3aa0" } : {}
                          }
                        >
                          {newNotifications.length}
                        </span>
                      )}
                    </span>
                  }
                  {...a11yProps(0)}
                />
                <Tab label={<span>Wyświetlone</span>} {...a11yProps(1)} />
              </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
              <ListNotifications
                data={newNotifications}
                index={value}
                action={action}
              />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <ListNotifications
                data={notifications}
                index={value}
                action={action}
              />
            </TabPanel>
          </Box>
        </div>
      </ClickAwayListener>
    </div>
  );
}
